module.exports = __webpack_public_path__ + "img/Effective Negotiator.9ef1cf6f.svg";